"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2m0 14.97-4.21-1.81-.79-.34-.79.34L7 17.97V5h10z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m7 17.97 4.21-1.81.79-.34.79.34L17 17.97V5H7z",
  opacity: ".3"
}, "1")], 'TurnedInTwoTone');